import { CommonModule } from '@angular/common';
import { DocPrintTemplatesStore } from '../../../../doc-templates/doc-print-templates/state/doc-print-template.store';
import { SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { VehicleDto, VehicleService } from '@digiwall/goliath-contacts/proxy';
import { DocRole } from '@digiwall/goliath-core/proxy';
import { tap } from 'rxjs';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { DwInputAutoCompleteDirective, ErrorFormControlDirective } from '@digiwall/core';
import { DwInputDirective } from '@digiwall/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AutoSizedDropdownDirective } from '@digiwall/ui-kit';

@Component({
  selector: 'document-doc-supplier-others',
  templateUrl: './doc-supplier-others.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    ErrorFormControlDirective,
    DwInputDirective,
    NgSelectComponent,
    AutoSizedDropdownDirective,
    LocalizationModule,
    DwInputAutoCompleteDirective,
  ],
})
export class DocSupplierOthersComponent implements OnInit {
  @Input() docForm: FormGroup;
  @Input() docRoleInput: DocRole;

  docRole = DocRole;

  docPrintTemplatesTypeStore = inject(DocPrintTemplatesStore);

  vehicles: VehicleDto[];

  constructor(
    private subscriptionService: SubscriptionService,
    private vehicleService: VehicleService,
  ) {
    this.vehicleService.getAll().subscribe(x => {
      this.vehicles = x;
    });
  }

  ngOnInit(): void {
    this.subscriptionService.addOne(
      this.docForm.get('litigation').valueChanges.pipe(
        tap(value => {
          if (!value) {
            this.docForm.controls.litigationReason.setValue(null);
            this.docForm.controls.litigationReason.updateValueAndValidity();
          }
        }),
      ),
    );

    this.subscriptionService.addOne(
      this.docForm.get('isBlocked').valueChanges.pipe(
        tap(value => {
          if (!value) {
            this.docForm.controls.blockedReason.setValue(null);
            this.docForm.controls.blockedReason.updateValueAndValidity();
          }
        }),
      ),
    );
  }
}
